import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { TotalAndDescription } from '../../../TotalAndDescription'
import { useSaveDraftLeadFilters, defaultFilters } from '@user/store/draftLeads'
import { IOption } from '@user/components/Filters/typings/IOption'

interface Props {
  count: number
  canViewLeads: boolean
  branches: IOption[]
}

export const PendingLeads: FC<Props> = (props) => {
  const { count, canViewLeads, branches } = props
  const navigate = useNavigate()
  const saveDraftLeadFilters = useSaveDraftLeadFilters()

  const callToAction = useCallback(() => {
    if (branches && branches.length > 0) {
      saveDraftLeadFilters({
        ...defaultFilters,
        filters: {
          ...defaultFilters.filters,
          branchId: {
            ...defaultFilters.filters.branchId,
            value: { mode: 'any', options: branches },
          },
        },
      })
    } else {
      saveDraftLeadFilters({
        ...defaultFilters,
        filters: {
          ...defaultFilters.filters,
        },
      })
    }

    navigate('/pending-leads')
  }, [navigate, branches])

  return (
    <TotalAndDescription
      testIdPrefix="pending-leads-widget"
      callToActionFunction={callToAction}
      callToActionText="Review"
      callToActionAllowed={canViewLeads}
      description={
        <>
          Review these Leads that have been submitted to Sales Center to qualify
          them.
        </>
      }
      headerText="Pending Leads"
      total={count}
    />
  )
}

PendingLeads.displayName = 'PendingLeads'
